import React, { Fragment, useState, useEffect } from 'react'
import DataTable from 'react-data-table-component'
import SearchComponent from '../../_Components/SearchComponent';
import SettingsModal from '../_Components/SettingsModal';
import RenderProfilePicture from '../../../../../../_helpers/profile-picture';
import RemoveTeamMemberModal from '../_Components/RemoveTeamMemberModal';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function ListTeamMembers({ 
  user,
  handleReload,
  teamMembers,
  handleShowAddToTeam, 
}) {

  const [data, setData] = useState()
  const [member, setMember] = useState()

  const [removeModal, setRemoveModal] = useState(false)
  const [showSettingsModal, setShowSettingsModal] = useState(false)

  useEffect(() => {
    setData(teamMembers)
  }, [teamMembers])

  const columns = [
    {
      name: 'USERS',
      sort: false,
      cell: row => {
        let fullName = `${row.firstName} ${row.lastName}`

        if (row.credentials) {
          fullName = `${fullName}, ${row.credentials}`
        }

        return <div className='row w-100'>
          <div className="col-auto">
            <RenderProfilePicture height={30} width={30} image={row.profileUrl} circle cached={false} className='m-auto' />
          </div>
          <div className="col-auto">
            <div className="row">
              <div className="col">
                <div>{fullName}</div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <span className='text-muted'>{row.specialtyTitle}</span>
              </div>
            </div>
          </div>
        </div>
      }
    },
    {
      name: '',
      sort: false,
      cell: row => {
        return <div className='w-100 d-flex justify-content-end'>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>View Staff</Tooltip>}
          >
            <Link
              as={Button}
              className="btn btn-outline-primary btn-sm mr-2"
              to={`/account/users/${row.userId}`}>
              <i className="fa fa-eye"></i>
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Remove Member</Tooltip>}
          >
            <button 
              title="Remove"
              onClick={() => {
                setMember(row)
                setRemoveModal(true)
              }}
              className="btn btn-outline-danger btn-sm mr-2">
              <i className="far fa-trash-alt"></i>
            </button>
          </OverlayTrigger>
        </div>
      }
    },
  ];

  const filterByName = (search) => {
    if (!search) {
      setData(teamMembers);
    } else {
      setData(teamMembers.filter(row => {
        return row.firstName.toLowerCase().indexOf(search.toLowerCase()) !== -1 || row.lastName.toLowerCase().indexOf(search.toLowerCase()) !== -1
      }))
    }
  }

  return (
    <Fragment>
      <SettingsModal 
        user={user}
        show={showSettingsModal}
        handleClose={() => setShowSettingsModal(false)}
      />

      <RemoveTeamMemberModal 
        user={user}
        member={member}
        show={removeModal}
        handleClose={(reloadData) => {
          setRemoveModal(false)

          if (reloadData) {
            handleReload()
          }
        }}
      />

      <div className='lead pb-3'>Team Members</div>
      <Row>
         <Col>
          <div className="axs-shadow axs-rounded p-1 mb-3" style={{background: 'white'}}>
            <DataTable
              noHeader
              data={data}
              columns={columns}
              subHeader
              subHeaderComponent={<SearchComponent placeholder="Search Team Member" handleSearch={search => filterByName(search) } />}
              pagination={false}
              customStyles={{ 
                cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
                headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
                subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
              }}
            />
          </div>
         </Col>
         <Col xs='3'>
           <Row>
             <Col>
                <Button 
                  block 
                  variant='success' 
                  className='font-weight-light' 
                  onClick={handleShowAddToTeam}>
                    Add Members
                </Button>

                <Button
                  onClick={ () => setShowSettingsModal(true) }
                  block
                  variant="outline-primary"  
                  className='font-weight-light mt-3'
                >Settings</Button>
             </Col>
           </Row>
         </Col>
      </Row>
    </Fragment>
  )
}
